import axios from 'axios';
import config from "./Config";
import { jwtDecode } from 'jwt-decode';

//const baseUrl = config.baseUrl;
//const API_URL = `${baseUrl}/Cuentas/Login`;

export const login = async (userName, password) => {
  try {
    console.log('AUTH_BASE:', config.authBaseUrl);
    console.log('API_BASE:', config.baseUrl);

    const API_URL = `${config.authBaseUrl}/Cuentas/Login`;

    const response = await axios.post(
      API_URL,
      { userName, password },
      {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      }
    );

    if (response.status === 200) {
      const { token } = response.data;

      // ✅ Decodifica el token para extraer los roles
      const decoded = jwtDecode(token);
      const roles = decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] || [];

      // Guarda en localStorage
      localStorage.setItem('authToken', token); // usa 'token', no 'authToken'
      localStorage.setItem('userRoles', JSON.stringify(roles));
      localStorage.setItem('email', userName);

      return response.data;
    } else {
      throw new Error('Login failed');
    }
  } catch (error) {
    console.log('Error during login:', error);
    throw error;
  }
};
